module.exports = __webpack_public_path__ + "img/Clock.4a8d3040.svg";